import { useEffect, useState } from 'react';
import { api, fmt, getUser } from '../api';
import { Modal, Field, Input, useToast, Loading, Eyebrow } from '../ui';
import { Icons } from '../icons';

export default function CustomsGroups() {
  const [list, setList] = useState<any[]>([]);
  const [edit, setEdit] = useState<any>(null);
  const [view, setView] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const user = getUser();
  const canEdit = ['admin', 'rastamojka'].includes(user?.role);

  const load = () => { setLoading(true); api.get('/customs-groups').then((d) => { setList(d); setLoading(false); }).catch((e) => { toast(e.message, true); setList([]); setLoading(false); }); };
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      // '' -> null (qiymatni tozalash mumkin); 0 ham haqiqiy qiymat sifatida saqlanadi
      const numOrNull = (v: any) => (v === '' || v === undefined || v === null ? null : +v);
      const body = { ...edit, basePrice: numOrNull(edit.basePrice), altRateEurKg: numOrNull(edit.altRateEurKg), vatPct: edit.vatPct !== '' && edit.vatPct != null ? +edit.vatPct : 12 };
      if (edit.id) await api.patch('/customs-groups/' + edit.id, body);
      else await api.post('/customs-groups', body);
      toast('Saqlandi'); setEdit(null); load();
    } catch (e: any) { toast(e.message, true); }
  };
  const remove = async (id: number) => {
    if (!confirm("Guruhni o'chirasizmi?")) return;
    try { await api.del('/customs-groups/' + id); toast("O'chirildi"); load(); }
    catch (e: any) { toast(e.message, true); }
  };
  const openView = (id: number) => api.get('/customs-groups/' + id).then(setView).catch((e) => toast(e.message, true));

  if (loading) return <Loading />;

  return (
    <div>
      <div className="page-head">
        <div>
          <h1 className="page-title">Rastamojka guruhlari</h1>
          <p className="page-sub">{list.length} ta guruh · «Rastamojka nomi» spravochnigi</p>
        </div>
        {canEdit && <button className="btn btn-primary" onClick={() => setEdit({ form: 'kg', vatPct: 12 })}>+ Yangi guruh</button>}
      </div>

      <div className="table-wrap">
        <table>
          <thead><tr><th>Guruh nomi</th><th>Shakli</th><th>TNVED</th><th className="num">Alt. €/kg</th><th className="num">Baza narx</th><th className="num">Mahsulot</th><th></th></tr></thead>
          <tbody>
            {list.map((g) => (
              <tr key={g.id}>
                <td style={{ cursor: 'pointer', color: 'var(--accent)' }} onClick={() => openView(g.id)}>{g.name} {g.powerLabel ? `(${g.powerLabel})` : ''}</td>
                <td><span className="badge b-confirmed">{g.form === 'piece' ? 'Donaga' : 'Kilogramda'}</span></td>
                <td className="code">{g.tnved}</td>
                <td className="num">{g.altRateEurKg ? fmt(g.altRateEurKg, 2) : '—'}</td>
                <td className="num">{g.basePrice ? '$' + fmt(g.basePrice, 4) : '—'}</td>
                <td className="num">{g._count?.products ?? 0}</td>
                <td>{canEdit && <div className="act-row">
                  <button className="act act-edit" title="Tahrirlash" onClick={() => setEdit({ ...g })}><Icons.edit size={16} /></button>
                  <button className="act act-del" title="O'chirish" onClick={() => remove(g.id)}><Icons.trash size={16} /></button>
                </div>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {edit && (
        <Modal title={edit.id ? 'Guruhni tahrirlash' : 'Yangi guruh'} onClose={() => setEdit(null)}>
          <div className="grid-2">
            <Field label="Guruh nomi *"><Input value={edit.name || ''} onChange={(e) => setEdit({ ...edit, name: e.target.value })} /></Field>
            <Field label="Quvvat ajratgichi"><Input value={edit.powerLabel || ''} onChange={(e) => setEdit({ ...edit, powerLabel: e.target.value })} /></Field>
            <Field label="TNVED (10 raqam) *"><Input value={edit.tnved || ''} maxLength={10} onChange={(e) => setEdit({ ...edit, tnved: e.target.value })} /></Field>
            <Field label="Rastamojka shakli *">
              <select className="input" value={edit.form} onChange={(e) => setEdit({ ...edit, form: e.target.value })}>
                <option value="kg">Kilogramda</option><option value="piece">Donaga</option>
              </select>
            </Field>
            <Field label="Alternativa (€/kg)"><Input type="number" step="0.01" value={edit.altRateEurKg ?? ''} onChange={(e) => setEdit({ ...edit, altRateEurKg: e.target.value })} /></Field>
            <Field label={'Baza narxi (' + (edit.form === 'piece' ? '$/dona' : '$/kg') + ')'}><Input type="number" step="0.0001" value={edit.basePrice ?? ''} onChange={(e) => setEdit({ ...edit, basePrice: e.target.value })} /></Field>
            <Field label="NDS %"><Input type="number" value={edit.vatPct ?? 12} onChange={(e) => setEdit({ ...edit, vatPct: e.target.value })} /></Field>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 10 }}>
            <button className="btn" onClick={() => setEdit(null)}>Bekor</button>
            <button className="btn btn-primary" onClick={save}>Saqlash</button>
          </div>
        </Modal>
      )}

      {view && (
        <Modal title={view.name} onClose={() => setView(null)} large>
          <p className="muted">
            TNVED <span className="code">{view.tnved}</span> · {view.form === 'piece' ? 'Donaga' : 'Kilogramda'}
            {view.altRateEurKg ? ` · Alternativa ${fmt(view.altRateEurKg, 2)} €/kg` : ''}
            {view.basePrice ? ` · Baza $${fmt(view.basePrice, 4)}` : ''}
          </p>
          <Eyebrow title={`Guruh tarkibi — ${view.products.length} mahsulot`} desc="sotuv narxi bo'yicha kamayish tartibida" />
          {!view.products.length ? <p className="muted">Bu guruhga hali mahsulot biriktirilmagan</p> : (
            <div className="table-wrap" style={{ maxHeight: 420, overflowY: 'auto' }}>
              <table>
                <thead><tr><th>Artikul</th><th>Nomi</th><th>Quvvat</th><th className="num">Korobkada</th><th className="num">Sotuv narxi</th></tr></thead>
                <tbody>
                  {[...view.products]
                    .sort((a: any, b: any) => Number(b.salePrice?.saleUsd ?? 0) - Number(a.salePrice?.saleUsd ?? 0))
                    .map((p: any) => (
                      <tr key={p.id}>
                        <td className="code">{p.article}</td>
                        <td>{p.name}</td>
                        <td>{p.powerLabel || '—'}</td>
                        <td className="num">{p.boxQty ?? '—'}</td>
                        <td className="num">{p.salePrice?.saleUsd ? '$' + fmt(p.salePrice.saleUsd, 2) : '—'}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          )}
          <h4 style={{ marginTop: 16 }}>Invoys narxlar tarixi</h4>
          {!view.priceHistory.length ? <p className="muted">Hali tarix yo'q</p> : (
            <div className="table-wrap">
              <table>
                <thead><tr><th>Sana</th><th>GTD</th><th className="num">Miqdor</th><th className="num">Invoys narx</th></tr></thead>
                <tbody>{view.priceHistory.map((h: any) => (
                  <tr key={h.id}><td>{new Date(h.date).toLocaleDateString('ru-RU')}</td><td>{h.gtdNumber || '—'}</td><td className="num">{fmt(h.qty)}</td><td className="num">{fmt(h.invoicePrice, 4)} {h.currency}</td></tr>
                ))}</tbody>
              </table>
            </div>
          )}
        </Modal>
      )}
    </div>
  );
}
